import React, { useEffect, useState } from "react";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import WhatsAppButton from "@/components/WhatsAppButton";
import { api } from "@/lib/api";

const DEFAULT_IMAGES = Array.from({ length: 9 }, (_, i) => `/pmr-photos/pmr-${i + 1}.jpg`);

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [hp, setHp] = useState(null);

  useEffect(() => {
    api.get("/public/gallery").then((r) => setItems(r.data || [])).catch(() => {});
    api.get("/public/homepage").then((r) => setHp(r.data)).catch(() => {});
  }, []);

  const displayItems = items.length
    ? items
    : DEFAULT_IMAGES.map((u, i) => ({ id: `d${i}`, url: u, caption: "PMR Impact Story" }));

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <section className="bg-slate-50 border-b border-slate-200 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#F59E0B]">Gallery</div>
          <h1 className="heading mt-3 text-4xl sm:text-5xl font-bold">Moments from the field.</h1>
          <p className="mt-4 max-w-2xl text-slate-600">Real stories from communities we serve.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="masonry">
          {displayItems.map((it) => (
            <div key={it.id} className="rounded-2xl overflow-hidden border border-slate-200 group cursor-pointer">
              <img
                src={it.url}
                alt={it.caption || "Gallery"}
                className="w-full h-auto group-hover:scale-105 transition-transform duration-500"
                data-testid={`gallery-img-${it.id}`}
              />
              {it.caption && (
                <div className="p-3 text-sm text-slate-600">{it.caption}</div>
              )}
            </div>
          ))}
        </div>
      </section>
      <PublicFooter contact={hp} />
      <WhatsAppButton number={hp?.whatsapp_number} />
    </div>
  );
}
